import { render } from "./MemberHeader.vue?vue&type=template&id=53ea4926&scoped=true"
import script from "./MemberHeader.vue?vue&type=script&lang=js"
export * from "./MemberHeader.vue?vue&type=script&lang=js"

import "./MemberHeader.vue?vue&type=style&index=0&id=53ea4926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ea4926"]])

export default __exports__